{
    "ACDStatusHotKeys_Success_Available": "Agent \"{}\" is available",
    "ACDStatusHotKeys_Success_Unavailable": "Agent \"{}\" is unavailable",

    "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Could not set \"{}\" to available.\nThis Agent may already be available or signed out.",
    "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Could not set \"{}\" to unavailable.\nThis Agent may already be unavailable or signed out.",

    "NAME": "ACDStatusHotKeys"
}
